import React from 'react';

export const AboutGame = () => {
  const stats = [
    { icon: 'solar:gamepad-charge-linear', label: 'ALL FIVES RULES', sub: 'Authentic Muggins gameplay, reimagined', accent: 'bg-yellow-400 text-black', skew: '-skew-x-3' },
    { icon: 'solar:shield-check-linear', label: 'SKILL-BASED WIN', sub: 'Strategy beats luck every time', accent: 'bg-white text-black', skew: 'skew-x-3' },
    { icon: 'solar:users-group-rounded-linear', label: '2–4 PLAYERS', sub: 'Solo battles to full team wars', accent: 'bg-black text-white border-2 border-yellow-400', skew: '-skew-x-3' },
  ];

  return (
    <section className="relative bg-black text-white py-24 overflow-hidden border-t-8 border-yellow-400">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-halftone opacity-5 pointer-events-none"></div>
      <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-yellow-400 transform rotate-45 opacity-5"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="inline-block bg-yellow-400 text-black px-6 py-2 font-anton text-sm tracking-widest uppercase transform -skew-x-12 mb-10 shadow-[4px_4px_0px_#fff]">
          🧠 ABOUT THE GAME
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-anton text-6xl md:text-8xl uppercase leading-none transform -rotate-1 mb-6">
              NOT YOUR<br />
              <span className="bg-yellow-400 text-black px-2">AVERAGE</span><br />
              DOMINO<span className="text-yellow-400">.</span>
            </h2>
            <p className="font-marker text-gray-300 text-xl border-l-4 border-yellow-400 pl-4 mb-6 leading-relaxed">
              Cutthroat Dominoes Master is a strategic, competitive, and customizable All Fives experience built for serious players.
            </p>
            <p className="font-sans text-gray-400 leading-relaxed">
              We took the classic All Fives (Muggins) rules and enhanced them with smart gameplay options, competitive twists, and modern features — while keeping the core authentic. Whether you're a casual player or a hardcore competitor, this is where skill meets strategy.
            </p>
          </div>

          <div className="space-y-4">
            {stats.map((s, i) => (
              <div key={i} className={`${s.accent} ${s.skew} p-4 flex items-center gap-4 hover:translate-x-2 transition-transform duration-300 shadow-[4px_4px_0px_rgba(234,179,8,0.4)] cursor-default`}>
                <iconify-icon icon={s.icon} width="40" className="flex-shrink-0"></iconify-icon>
                <div>
                  <div className="font-anton text-xl">{s.label}</div>
                  <div className="font-sans text-sm opacity-70">{s.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
